import { pathOr } from 'ramda'

export const useOfferAcceptability = ({ offer }) => {
  const productAcceptability = pathOr(true, ['value', 'acceptability'], offer)
  const wineAcceptability = pathOr(
    true,
    ['value', 'wine', 'acceptability'],
    offer
  )
  const brandAcceptability = pathOr(
    true,
    ['value', 'wine', 'brand', 'acceptability'],
    offer
  )
  const tradeNameAcceptability = pathOr(
    true,
    ['value', 'wine', 'tradeName', 'acceptability'],
    offer
  )

  return {
    acceptability:
      productAcceptability &&
      wineAcceptability &&
      brandAcceptability &&
      tradeNameAcceptability,
  }
}
